import React, { useState, useEffect, useRef } from 'react';
import Swal from 'sweetalert2';
import { useNavigate, Link } from 'react-router-dom';
import db from "./Firebase";
import { storage } from './Firebase';
import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
import { doc, getDoc, setDoc, getDocs, collection, query, orderBy, onSnapshot } from "firebase/firestore";
import Moment from 'moment';
import { extendMoment } from 'moment-range';
import Multiselect from 'multiselect-react-dropdown';

function ExpertUploadPage() {
    const navigate = useNavigate();
    const moment = extendMoment(Moment);

    // State for profile image upload & preview
    const [profileImageFile, setProfileImageFile] = useState(null);
    const [profileImagePreview, setProfileImagePreview] = useState("");

    const fileInputRef = useRef(null);
    const fileInputRefs = useRef(null);

    // Initial state for expert details
    const initialExpertData = {
        id: "",
        bio: "",
        insta_id: "",
        name: "",
        phone_no: "",
        profile_image: "",
        username: "",
        picture_gallery: [],
        created_date: new Date(),
        updated_date: new Date()
    };

    // Component state
    const [userData, setUserData] = useState(initialExpertData);
    const [data, setData] = useState([]);
    const [editID, setEditID] = useState("");
    const [edit, setEdit] = useState(false);
    const [selectedValue, setSelectedValue] = useState([]);
    const [experts, setExperts] = useState([]);
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(false);
    const [customDocId, setCustomDocId] = useState(""); // Custom document ID for Firestore

    // Multiselect handlers (if needed)
    const onSelect = (selectedList, selectedItem) => {
        setSelectedValue(selectedList);
    };

    const onRemove = (selectedList, removedItem) => {
        setSelectedValue(selectedList);
    };

    // Check for user authentication on mount
    useEffect(() => {
        const storedUsername = localStorage.getItem("email");
        const storedPassword = localStorage.getItem("password");
        const storedRemember = localStorage.getItem("remember");

        if (storedRemember === "false" || !storedUsername || !storedPassword) {
            navigate('/signin');
        }
    }, [navigate]);

    // Handle input changes for text fields
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setUserData({ ...userData, [name]: value });
    };

    // Handle changes for the custom document ID field
    const handleCustomDocIdChange = (e) => {
        setCustomDocId(e.target.value);
    };

    // Handle profile image selection and preview
    const handleProfileImageChange = (e) => {
        const file = e.target.files[0];
        setProfileImageFile(file);
        if (file) {
            setProfileImagePreview(URL.createObjectURL(file));
        }
    };

    // Handle additional image selection (for picture gallery)
    const handleImageChange = (e) => {
        setImages([...e.target.files]);
    };

    // Upload the profile image and return its URL
    const uploadProfileImage = async () => {
        if (!profileImageFile) return "";
        const storageRef = ref(storage, `profile_images/${profileImageFile.name}`);
        const uploadTask = uploadBytesResumable(storageRef, profileImageFile);
        return new Promise((resolve, reject) => {
            uploadTask.on(
                "state_changed",
                null,
                (error) => reject(error),
                async () => {
                    const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                    resolve(downloadURL);
                }
            );
        });
    };

    // Upload gallery images and return their URLs
    const uploadImagesToFirestore = async () => {
        const uploadedImageUrls = [];
        for (const image of images) {
            const storageRef = ref(storage, `images/${image.name}`);
            const uploadTask = uploadBytesResumable(storageRef, image);
            await new Promise((resolve, reject) => {
                uploadTask.on(
                    "state_changed",
                    null,
                    (error) => reject(error),
                    async () => {
                        const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                        uploadedImageUrls.push(downloadURL);
                        resolve();
                    }
                );
            });
        }
        return uploadedImageUrls;
    };

    // Placeholder functions for modal control (adjust to your modal implementation)
    const openModalShow = () => {
        window.openModelshow();
    };

    const closeModel = () => {
        window.openModelNew();
    };

    // Submit handler for adding/updating expert details
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            // Only check for duplicate customDocId if not editing
            if (!edit) {
                const docRef = doc(db, 'nv_expert_details', customDocId);
                const docSnap = await getDoc(docRef);
                if (docSnap.exists()) {
                    alert("Custom Document ID already exists. Please change the ID.");
                    setLoading(false);
                    return; // Exit without updating
                }
            }

            // Use new profile image if selected; otherwise, keep the existing one
            const profileImageURL = profileImageFile
                ? await uploadProfileImage()
                : userData.profile_image;

            // Use new gallery images if any are selected; otherwise, keep the existing gallery
            const uploadedGallery = images.length > 0
                ? await uploadImagesToFirestore()
                : userData.picture_gallery;

            const finalData = {
                ...userData,
                profile_image: profileImageURL,
                picture_gallery: uploadedGallery,
                updated_date: new Date()
            };

            await setDoc(doc(db, 'nv_expert_details', customDocId), finalData);
            alert("Expert data uploaded successfully!");
            // Reset form fields if needed...
        } catch (error) {
            console.error("Error uploading data:", error);
            alert("Error uploading data.");
        } finally {
            setLoading(false);
        }
    };


    // Prepare the form for editing an existing expert's details
    // const changeStatus = (expertData, id) => {
    //     setEdit(true);
    //     setEditID(id);
    //     const dataFromDatabase = expertData.location
    //         ? expertData.location.map((name) => ({ name }))
    //         : [];
    //     setSelectedValue(dataFromDatabase);
    //     setUserData({
    //         bio: expertData.bio,
    //         insta_id: expertData.insta_id,
    //         name: expertData.name,
    //         phone_no: expertData.phone_no,
    //         profile_image: expertData.profile_image,
    //         username: expertData.username,
    //         picture_gallery: expertData.picture_gallery,
    //         created_date: expertData.created_date ? expertData.created_date.toDate() : new Date(),
    //         updated_date: new Date()
    //     });
    //     setCustomDocId(id);
    //     openModalShow();
    // };
    const changeStatus = (expertData, id) => {
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
        if (fileInputRefs.current) {
            fileInputRefs.current.value = "";
        }
        setProfileImagePreview("");
        setProfileImageFile(null);
        setEdit(true);
        setEditID(id);
        const dataFromDatabase = expertData.location
            ? expertData.location.map((name) => ({ name }))
            : [];
        setSelectedValue(dataFromDatabase);
        setUserData({
            bio: expertData.bio,
            insta_id: expertData.insta_id,
            name: expertData.name,
            phone_no: expertData.phone_no,
            profile_image: expertData.profile_image, // stored URL remains unchanged
            username: expertData.username,
            picture_gallery: expertData.picture_gallery,
            created_date: expertData.created_date ? expertData.created_date.toDate() : new Date(),
            updated_date: new Date()
        });
        setCustomDocId(id);

        // Clear the local preview and file for the profile image so the input appears blank
        setProfileImagePreview("");
        setProfileImageFile(null);

        openModalShow();
    };


    // Prepare the form for adding a new expert
    const addNew = () => {
        // Clear the file input field via ref:
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
        if (fileInputRefs.current) {
            fileInputRefs.current.value = "";
        }
        setProfileImagePreview("");
        setProfileImageFile(null);
        setEdit(false);
        setCustomDocId("");
        setUserData(initialExpertData);
        setSelectedValue([]);
        openModalShow();
    };

    // Fetch experts for display
    useEffect(() => {
        const fetchExperts = async () => {
            try {
                const querySnapshot = await getDocs(collection(db, "nv_expert_details"));
                const expertsList = querySnapshot.docs.map((doc) => ({
                    id: doc.id,
                    name: doc.data().name || "Unnamed Expert"
                }));
                setExperts(expertsList);
            } catch (error) {
                console.error("Error fetching experts: ", error);
            }
        };
        fetchExperts();
    }, []);

    // Listen for real-time updates (for displaying the list of experts)
    useEffect(() => {
        const q = query(collection(db, "nv_expert_details"), orderBy("created_date", "desc"));
        const unsubscribe = onSnapshot(q, (snapshot) => {
            setData(
                snapshot.docs.map((doc) => ({
                    id: doc.id,
                    data: doc.data(),
                }))
            );
        });
        return () => unsubscribe();
    }, []);

    return (
        <>
            <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg">
                <div className="p-2" style={{ textAlign: "start", paddingBottom: "5px" }}>
                    <Link to="/">
                        <img src="/images/menubutton.png" className="menu-toggle" alt="Responsive" style={{ height: "2rem" }} />
                    </Link>
                </div>
                <div className="p-2">
                    <div style={{ textAlign: "end", paddingBottom: "5px" }}>
                        <button className="btn bg-gradient-primary btn-sm mb-0" style={{ color: "white" }} onClick={addNew}>
                            + Add Expert Details
                        </button>
                    </div>
                    <div className="card">
                        <div>
                            <div className="table-responsive fix-width scroll-inner">
                                <table className="table table-bordered table-hover">
                                    <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
                                        <tr style={{ textAlign: "left" }}>
                                            <th className="col">Expert</th>
                                            <th className="col ps-2">Phone</th>
                                            <th className="text-center col">Username</th>
                                            <th className="text-center col">Insta ID</th>
                                            <th className="text-center col">Created Date</th>
                                            <th className="text-center col">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{ textAlign: "left" }}>
                                        {data?.map(({ id, data: expertData }) => (
                                            <tr key={id}>
                                                <td>
                                                    <div className="d-flex px-2 py-1">
                                                        <div style={{ width: "7rem", marginRight: "13px" }}>
                                                            <img
                                                                src={expertData.profile_image}
                                                                className="me-3"
                                                                style={{ height: "4rem" }}
                                                                alt={expertData.name}
                                                            />
                                                        </div>
                                                        <div className="d-flex flex-column justify-content-center">
                                                            <h6 className="mb-0 text-xs">{id} - {expertData.name}</h6>
                                                            <p
                                                                className="text-xs text-secondary mb-0 btn-tooltip"
                                                                title={expertData.bio}
                                                                style={{
                                                                    whiteSpace: "nowrap",
                                                                    width: "20rem",
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis"
                                                                }}
                                                            >
                                                                <i className="material-icons" style={{ fontSize: "12px", color: "#e73573" }}>
                                                                    info
                                                                </i>{" "}
                                                                {expertData.bio}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <p className="text-xs font-weight-bold mb-0">{expertData.phone_no}</p>
                                                </td>
                                                <td className="align-middle text-center text-sm">
                                                    <span className="badge badge-sm badge-success">{expertData.username}</span>
                                                </td>
                                                <td className="align-middle text-center text-sm">
                                                    <span className="badge badge-sm badge-success">{expertData.insta_id}</span>
                                                </td>
                                                <td className="align-middle text-center text-sm">
                                                    <span className="text-secondary text-xs font-weight-normal">
                                                        {moment(expertData.created_date.toDate().toISOString()).format("MM/DD/YY, h:mm a")}
                                                    </span>
                                                </td>
                                                <td className="align-middle text-center" onClick={() => changeStatus(expertData, id)}>
                                                    <span className="text-info text-xs font-weight-normal" style={{ cursor: "pointer" }}>
                                                        Edit
                                                    </span>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            {/* Modal for adding/updating expert details */}
            <div className="col-md-12">
                <div
                    className="myId modal fade"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="modal-form"
                    aria-hidden="true"
                    data-backdrop="static"
                >
                    <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    {edit ? "Edit Expert Details" : "Add Expert Details"}
                                </h5>
                                <button type="button" className="close" onClick={closeModel}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <form onSubmit={handleSubmit} id="expertForm">
                                    <label>Expert ID:</label>
                                    <input
                                        type="text"
                                        value={customDocId}
                                        onChange={handleCustomDocIdChange}
                                        required
                                        placeholder="Enter expert ID (e.g., e1, e2, etc.)"
                                        disabled={edit}
                                        style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
                                    />
                                    <div>
                                        <label>Bio:</label>
                                        <textarea
                                            name="bio"
                                            value={userData.bio}
                                            onChange={handleInputChange}
                                            required
                                            style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
                                        ></textarea>
                                    </div>
                                    <div>
                                        <label>Instagram ID:</label>
                                        <input
                                            type="text"
                                            name="insta_id"
                                            value={userData.insta_id}
                                            onChange={handleInputChange}
                                            required
                                            style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
                                        />
                                    </div>
                                    <div>
                                        <label>Name:</label>
                                        <input
                                            type="text"
                                            name="name"
                                            value={userData.name}
                                            onChange={handleInputChange}
                                            required
                                            style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
                                        />
                                    </div>
                                    <div>
                                        <label>Phone Number:</label>
                                        <input
                                            type="text"
                                            name="phone_no"
                                            value={userData.phone_no}
                                            onChange={handleInputChange}
                                            required
                                            style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
                                        />
                                    </div>
                                    {/* Profile Image Upload */}
                                    <div>
                                        <label>Profile Image:</label>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={handleProfileImageChange}
                                            ref={fileInputRef}
                                            style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
                                        />
                                        {profileImagePreview && (
                                            <img
                                                src={profileImagePreview}
                                                alt="Profile Preview"
                                                style={{ maxWidth: "100%", marginBottom: "20px" }}
                                            />
                                        )}
                                    </div>
                                    <div>
                                        <label>Username:</label>
                                        <input
                                            type="text"
                                            name="username"
                                            value={userData.username}
                                            onChange={handleInputChange}
                                            style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
                                        />
                                    </div>
                                    {/* Picture Gallery Upload */}
                                    <div>
                                        <label>Picture Gallery (4 Images):</label>
                                        <input
                                            type="file"
                                            multiple
                                            accept="image/*"
                                            onChange={handleImageChange}
                                            ref={fileInputRefs}
                                            style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
                                        />
                                    </div>
                                    <div className="modal-footer">
                                        {edit ? (
                                            <>
                                                {/* <button type="button" className="btn btn-secondary" onClick={closeModel} disabled={loading}>
                                                    Close
                                                </button> */}
                                                <button type="submit" form="expertForm" className="btn btn-primary" disabled={loading}>
                                                    {loading ? "Please wait... Uploading" : "Update"}
                                                </button>
                                            </>
                                        ) : (
                                            <button type="submit" form="expertForm" className="btn btn-primary" disabled={loading}>
                                                {loading ? "Please wait... Uploading" : "Submit"}
                                            </button>
                                        )}
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ExpertUploadPage;


// import React, { useState, useEffect } from 'react';

// import Swal from 'sweetalert2';
// import { useNavigate, Link } from 'react-router-dom';
// import db from "./Firebase";
// import { storage } from './Firebase';
// import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
// import { doc, setDoc, getDocs, collection, query, orderBy, onSnapshot } from "firebase/firestore";
// import Moment from 'moment';
// import { extendMoment } from 'moment-range';
// import Multiselect from 'multiselect-react-dropdown';

// async function ExpertUploadPage() {
//     const navigate = useNavigate();
//     const moment = extendMoment(Moment);
//     const [profileImageFile, setProfileImageFile] = useState(null);
//     const [profileImagePreview, setProfileImagePreview] = useState("");

//     // Initial state for expert details
//     const initialExpertData = {
//         bio: "",
//         insta_id: "",
//         name: "",
//         phone_no: "",
//         profile_image: "",
//         username: "",
//         picture_gallery: [],
//         created_date: new Date(),
//         updated_date: new Date()
//     };


//     const handleProfileImageChange = (e) => {
//         const file = e.target.files[0];
//         setProfileImageFile(file);
//         // Create a local preview URL
//         if (file) {
//             setProfileImagePreview(URL.createObjectURL(file));
//         }
//     };

//     // State variables
//     const [userData, setUserData] = useState(initialExpertData);
//     const [data, setData] = useState([]);
//     const [editID, setEditID] = useState("");
//     const [edit, setEdit] = useState(false);
//     const [selectedValue, setSelectedValue] = useState([]);
//     const [experts, setExperts] = useState([]);
//     const [images, setImages] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [customDocId, setCustomDocId] = useState(""); // Custom document ID for Firestore

//     // Multiselect handlers (if you use it elsewhere in your form)
//     const onSelect = (selectedList, selectedItem) => {
//         setSelectedValue(selectedList);
//     };

//     const onRemove = (selectedList, removedItem) => {
//         setSelectedValue(selectedList);
//     };

//     // Check for user authentication on mount
//     useEffect(() => {
//         const storedUsername = localStorage.getItem("email");
//         const storedPassword = localStorage.getItem("password");
//         const storedRemember = localStorage.getItem("remember");

//         if (storedRemember === "false" || !storedUsername || !storedPassword) {
//             navigate('/signin');
//         }
//     }, [navigate]);

//     // Handle input changes for text fields
//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setUserData({ ...userData, [name]: value });
//     };

//     // Handle changes for the custom document ID field
//     const handleCustomDocIdChange = (e) => {
//         setCustomDocId(e.target.value);
//     };

//     // Handle image file selection
//     const handleImageChange = (e) => {
//         setImages([...e.target.files]);
//     };

//     const uploadProfileImage = async () => {
//         if (!profileImageFile) return "";
//         const storageRef = ref(storage, `profile_images/${profileImageFile.name}`);
//         const uploadTask = uploadBytesResumable(storageRef, profileImageFile);
//         return new Promise((resolve, reject) => {
//             uploadTask.on(
//                 "state_changed",
//                 null,
//                 (error) => reject(error),
//                 async () => {
//                     const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
//                     resolve(downloadURL);
//                 }
//             );
//         });
//     };

//     // In handleSubmit:
//     const profileImageURL = await uploadProfileImage();
//     const finalData = {
//         ...userData,
//         profile_image: profileImageURL,
//         // ...other fields
//     };


//     // Upload images to Firebase Storage and return their URLs
//     const uploadImagesToFirestore = async () => {
//         const uploadedImageUrls = [];
//         for (const image of images) {
//             const storageRef = ref(storage, `images/${image.name}`);
//             const uploadTask = uploadBytesResumable(storageRef, image);

//             await new Promise((resolve, reject) => {
//                 uploadTask.on(
//                     "state_changed",
//                     null,
//                     (error) => reject(error),
//                     async () => {
//                         const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
//                         uploadedImageUrls.push(downloadURL);
//                         resolve();
//                     }
//                 );
//             });
//         }
//         return uploadedImageUrls;
//     };

//     // Placeholder functions for opening/closing your modal.
//     // Adjust these to match your modal implementation.
//     const openModalShow = () => {
//         window.openModelshow();
//     };

//     const closeModel = () => {
//         window.openModelNew();
//     };

//     // Submit handler for adding/updating expert details
//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setLoading(true);

//         try {
//             const uploadedImageUrls = await uploadImagesToFirestore();
//             const finalData = {
//                 ...userData,
//                 picture_gallery: uploadedImageUrls,
//                 updated_date: new Date()
//             };

//             // Use the customDocId for both adding new and editing expert details.
//             await setDoc(doc(db, 'nv_expert_details', customDocId), finalData);

//             alert("Expert data uploaded successfully!");
//             // Reset form fields after successful upload
//             setUserData(initialExpertData);
//             setImages([]);
//         } catch (error) {
//             console.error("Error uploading data:", error);
//             alert("Error uploading data.");
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Prepare the form for editing an existing expert's details
//     const changeStatus = (expertData, id) => {
//         setEdit(true);
//         setEditID(id);
//         // If you have a multiselect field that depends on expertData.location, adjust accordingly.
//         const dataFromDatabase = expertData.location
//             ? expertData.location.map((name) => ({ name }))
//             : [];
//         setSelectedValue(dataFromDatabase);
//         setUserData({
//             bio: expertData.bio,
//             insta_id: expertData.insta_id,
//             name: expertData.name,
//             phone_no: expertData.phone_no,
//             profile_image: expertData.profile_image,
//             username: expertData.username,
//             picture_gallery: expertData.picture_gallery,
//             created_date: expertData.created_date ? expertData.created_date.toDate() : new Date(),
//             updated_date: new Date()
//         });
//         setCustomDocId(id);
//         openModalShow();
//     };

//     // Prepare the form for adding a new expert
//     const addNew = () => {
//         setEdit(false);
//         setCustomDocId("");
//         setUserData(initialExpertData);
//         setSelectedValue([]);
//         openModalShow();
//     };

//     // Fetch experts (for example, to show a dropdown or list)
//     useEffect(() => {
//         const fetchExperts = async () => {
//             try {
//                 const querySnapshot = await getDocs(collection(db, "nv_expert_details"));
//                 const expertsList = querySnapshot.docs.map((doc) => ({
//                     id: doc.id,
//                     name: doc.data().name || "Unnamed Expert"
//                 }));
//                 setExperts(expertsList);
//             } catch (error) {
//                 console.error("Error fetching experts: ", error);
//             }
//         };

//         fetchExperts();
//     }, []);

//     // Listen for real-time updates (for displaying the list of experts)
//     useEffect(() => {
//         const q = query(collection(db, "nv_expert_details"), orderBy("created_date", "desc"));
//         const unsubscribe = onSnapshot(q, (snapshot) => {
//             setData(
//                 snapshot.docs.map((doc) => ({
//                     id: doc.id,
//                     data: doc.data(),
//                 }))
//             );
//         });
//         return () => unsubscribe();
//     }, []);

//     return (
//         <>
//             <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg">
//                 <div className="p-2" style={{ textAlign: "start", paddingBottom: "5px" }}>
//                     <Link to="/">
//                         <img src="/images/menubutton.png" className="menu-toggle" alt="Responsive" style={{ height: "2rem" }} />
//                     </Link>
//                 </div>
//                 <div className="p-2">
//                     <div style={{ textAlign: "end", paddingBottom: "5px" }}>
//                         <button className="btn bg-gradient-primary btn-sm mb-0" style={{ color: "white" }} onClick={addNew}>
//                             + Add Expert Details
//                         </button>
//                     </div>
//                     <div className="card">
//                         <div>
//                             <div className="table-responsive fix-width scroll-inner">
//                                 <table className="table table-bordered table-hover">
//                                     <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
//                                         <tr style={{ textAlign: "left" }}>
//                                             <th className="col">Expert</th>
//                                             <th className="col ps-2">Phone</th>
//                                             <th className="text-center col">Username</th>
//                                             <th className="text-center col">Insta ID</th>
//                                             <th className="text-center col">Created Date</th>
//                                             <th className="text-center col">Action</th>
//                                         </tr>
//                                     </thead>
//                                     <tbody style={{ textAlign: "left" }}>
//                                         {data?.map(({ id, data: expertData }) => (
//                                             <tr key={id}>
//                                                 <td>
//                                                     <div className="d-flex px-2 py-1">
//                                                         <div style={{ width: "7rem", marginRight: "13px" }}>
//                                                             <img
//                                                                 src={expertData.profile_image}
//                                                                 className="me-3"
//                                                                 style={{ height: "4rem" }}
//                                                                 alt={expertData.name}
//                                                             />
//                                                         </div>
//                                                         <div className="d-flex flex-column justify-content-center">
//                                                             <h6 className="mb-0 text-xs">{expertData.name}</h6>
//                                                             <p
//                                                                 className="text-xs text-secondary mb-0 btn-tooltip"
//                                                                 title={expertData.bio}
//                                                                 style={{
//                                                                     whiteSpace: "nowrap",
//                                                                     width: "20rem",
//                                                                     overflow: "hidden",
//                                                                     textOverflow: "ellipsis"
//                                                                 }}
//                                                             >
//                                                                 <i className="material-icons" style={{ fontSize: "12px", color: "#e73573" }}>
//                                                                     info
//                                                                 </i>{" "}
//                                                                 {expertData.bio}
//                                                             </p>
//                                                         </div>
//                                                     </div>
//                                                 </td>
//                                                 <td>
//                                                     <p className="text-xs font-weight-bold mb-0">{expertData.phone_no}</p>
//                                                 </td>
//                                                 <td className="align-middle text-center text-sm">
//                                                     <span className="badge badge-sm badge-success">{expertData.username}</span>
//                                                 </td>
//                                                 <td className="align-middle text-center text-sm">
//                                                     <span className="badge badge-sm badge-success">{expertData.insta_id}</span>
//                                                 </td>
//                                                 <td className="align-middle text-center text-sm">
//                                                     <span className="text-secondary text-xs font-weight-normal">
//                                                         {moment(expertData.created_date.toDate().toISOString()).format("MM/DD/YY, h:mm a")}
//                                                     </span>
//                                                 </td>
//                                                 <td className="align-middle text-center" onClick={() => changeStatus(expertData, id)}>
//                                                     <span className="text-info text-xs font-weight-normal" style={{ cursor: "pointer" }}>
//                                                         Edit
//                                                     </span>
//                                                 </td>
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </main>

//             {/* Modal for adding/updating expert details */}
//             <div className="col-md-12">
//                 <div
//                     className="myId modal fade"
//                     id=""
//                     tabIndex="-1"
//                     role="dialog"
//                     aria-labelledby="modal-form"
//                     aria-hidden="true"
//                     data-backdrop="static"
//                 >
//                     <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
//                         <div className="modal-content">
//                             <div className="modal-header">
//                                 <h5 className="modal-title">
//                                     {edit ? "Edit Expert Details" : "Add Expert Details"}
//                                 </h5>
//                                 {/* Only show the close button when editing */}
//                                 {/* {edit && ( */}
//                                 <button type="button" className="close" onClick={closeModel}>
//                                     <span aria-hidden="true">&times;</span>
//                                 </button>
//                                 {/* )} */}
//                             </div>
//                             <div className="modal-body">
//                                 <form onSubmit={handleSubmit}>
//                                     <label>Expert ID:</label>
//                                     <input
//                                         type="text"
//                                         value={customDocId}
//                                         onChange={handleCustomDocIdChange}
//                                         required
//                                         placeholder="Enter expert ID (e.g., e1, e2, etc.)"
//                                         style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
//                                     />
//                                     <div>
//                                         <label>Bio:</label>
//                                         <textarea
//                                             name="bio"
//                                             value={userData.bio}
//                                             onChange={handleInputChange}
//                                             required
//                                             style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
//                                         ></textarea>
//                                     </div>
//                                     <div>
//                                         <label>Instagram ID:</label>
//                                         <input
//                                             type="text"
//                                             name="insta_id"
//                                             value={userData.insta_id}
//                                             onChange={handleInputChange}
//                                             required
//                                             style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
//                                         />
//                                     </div>
//                                     <div>
//                                         <label>Name:</label>
//                                         <input
//                                             type="text"
//                                             name="name"
//                                             value={userData.name}
//                                             onChange={handleInputChange}
//                                             required
//                                             style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
//                                         />
//                                     </div>
//                                     <div>
//                                         <label>Phone Number:</label>
//                                         <input
//                                             type="text"
//                                             name="phone_no"
//                                             value={userData.phone_no}
//                                             onChange={handleInputChange}
//                                             required
//                                             style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
//                                         />
//                                     </div>
//                                     {/* Profile Image Upload */}
//                                     <div>
//                                         <label>Profile Image:</label>
//                                         <input
//                                             type="file"
//                                             accept="image/*"
//                                             onChange={handleProfileImageChange}
//                                             style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
//                                         />
//                                         {profileImagePreview && (
//                                             <img
//                                                 src={profileImagePreview}
//                                                 alt="Profile Preview"
//                                                 style={{ maxWidth: "100%", marginBottom: "20px" }}
//                                             />
//                                         )}
//                                     </div>
//                                     <div>
//                                         <label>Username:</label>
//                                         <input
//                                             type="text"
//                                             name="username"
//                                             value={userData.username}
//                                             onChange={handleInputChange}
//                                             required
//                                             style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
//                                         />
//                                     </div>
//                                     <div>
//                                         <label>Picture Gallery (4 Images):</label>
//                                         <input
//                                             type="file"
//                                             multiple
//                                             accept="image/*"
//                                             onChange={handleImageChange}
//                                             required
//                                             style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
//                                         />
//                                     </div>
//                                     <div className="modal-footer">
//                                         {/* If editing, show Close and Update buttons */}
//                                         {edit ? (
//                                             <>
//                                                 {/* <button type="button" className="btn btn-secondary" onClick={closeModel}>
//                                                     Close
//                                                 </button> */}
//                                                 <button type="submit" form="expertForm" className="btn btn-primary">
//                                                     Update
//                                                 </button>
//                                             </>
//                                         ) : (
//                                             // Otherwise, show a Submit button for new expert details
//                                             <button type="submit" form="expertForm" className="btn btn-primary">
//                                                 Submit
//                                             </button>
//                                         )}
//                                     </div>
//                                 </form>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// }

// export default ExpertUploadPage;


// // import React, { useState, useEffect } from 'react';

// // import AdminPanel from './AdminPanel';
// // import Swal from 'sweetalert2'
// // import { useNavigate, Link, useParams } from 'react-router-dom';
// // import db from "./Firebase";
// // import { storage } from './Firebase';
// // import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
// // import { doc, setDoc, getDocs, collection } from "firebase/firestore";
// // import Moment from 'moment';
// // import { extendMoment } from 'moment-range';
// // import ViewAppData from './ViewAppData';
// // import Multiselect from 'multiselect-react-dropdown';


// // function ExpertUploadPage() {
// //     const navigate = useNavigate();
// //     const moment = extendMoment(Moment);
// //     const initialFormStateFeedback = {
// //         bio: "",
// //         insta_id: "",
// //         name: "",
// //         phone_no: "",
// //         profile_image: "",
// //         username: "",
// //         picture_gallery: [], created_date: new Date(), updated_date: new Date()
// //     }
// //     const [submit, setSubmit] = useState(initialFormStateFeedback)
// //     const [data, setData] = useState([]);
// //     const [editID, setEditID] = useState("");
// //     const [edit, setEdit] = useState(false);



// //     const [selectedValue, setSelectedValue] = useState([]);


// //     const onSelect = (selectedList, selectedItem) => {
// //         // Handle selection
// //         // ...
// //         setSelectedValue(selectedList);
// //     }

// //     const onRemove = (selectedList, removedItem) => {
// //         // Handle removal
// //         // ...
// //         setSelectedValue(selectedList);
// //     }

// //     useEffect(() => {
// //         const storedUsername = localStorage.getItem("email");
// //         const storedPassword = localStorage.getItem("password");
// //         const storedRemember = localStorage.getItem("remember");

// //         if (storedRemember === "false" || !storedUsername || !storedPassword) {
// //             navigate('/signin');
// //         }
// //     }, []);


// //     const handleChange = (e) => {
// //         const { id, value } = e.target
// //         setSubmit({ ...submit, [id]: value })
// //     }


// //     const [experts, setExperts] = useState([]);
// //     const [expert_name, setExpert_name] = useState([]);



// //     useEffect(() => {
// //         const fetchExperts = async () => {
// //             try {
// //                 const querySnapshot = await getDocs(collection(db, "nv_expert_details"));
// //                 setExperts(querySnapshot.docs.map((doc) => ({
// //                     id: doc.id,
// //                     name: doc.data().name || "Unnamed Expert"
// //                 })));
// //                 setExpert_name(querySnapshot.docs.map((doc) => ({
// //                     name: doc.data().name || "Unnamed Expert"
// //                 })));
// //             } catch (error) {
// //                 console.error("Error fetching experts: ", error);
// //             }
// //         };

// //         fetchExperts();
// //     }, []);

// //     const changeStatus = (data, id) => {
// //         setEdit(true)
// //         setEditID(id)
// //         const dataFromDatabase = data.location.map((name) => ({
// //             name: name, // Assuming your data has a 'name' field
// //         }));
// //         setSelectedValue(dataFromDatabase);
// //         setSubmit({
// //             id: id, bio: data.bio,
// //             insta_id: data.insta_id,
// //             name: data.name,
// //             phone_no: data.phone_no,
// //             profile_image: data.profile_image,
// //             username: data.username,
// //             picture_gallery: data.picture_gallery, updated_date: new Date(), created_date: new Date()
// //         });
// //         openModalShow();
// //     }

// //     const addNew = () => {
// //         setEdit(false)
// //         openModalShow();
// //         setSubmit({
// //             id: '', bio: "",
// //             insta_id: "",
// //             name: "",
// //             phone_no: "",
// //             profile_image: "",
// //             username: "",
// //             picture_gallery: [], created_date: new Date(), updated_date: new Date()
// //         });
// //     }

// //     // Handle changes in custom document ID input
// //     const handleCustomDocIdChange = (e) => {
// //         setCustomDocId(e.target.value);
// //     };


// //     const [images, setImages] = useState([]);
// //     const [loading, setLoading] = useState(false);

// //     const handleInputChange = (e) => {
// //         const { name, value } = e.target;
// //         setUserData({ ...userData, [name]: value });
// //     };

// //     const handleImageChange = (e) => {
// //         setImages([...e.target.files]);
// //     };

// //     const uploadImagesToFirestore = async () => {
// //         const uploadedImageUrls = [];
// //         for (const image of images) {
// //             const storageRef = ref(storage, `images/${image.name}`);
// //             const uploadTask = uploadBytesResumable(storageRef, image);

// //             await new Promise((resolve, reject) => {
// //                 uploadTask.on(
// //                     "state_changed",
// //                     null,
// //                     (error) => reject(error),
// //                     async () => {
// //                         const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
// //                         uploadedImageUrls.push(downloadURL);
// //                         resolve();
// //                     }
// //                 );
// //             });
// //         }
// //         return uploadedImageUrls;
// //     };


// //     const [customDocId, setCustomDocId] = useState(""); // Custom doc ID

// //     const openModalShow = () => {
// //         // alert("ooo")
// //         window.openModelshow();
// //     }

// //     const closeModel = () => {
// //         window.openModelNew();
// //     }

// //     const handleSubmit = async (e) => {
// //         e.preventDefault();
// //         setLoading(true);

// //         try {
// //             const uploadedImageUrls = await uploadImagesToFirestore();
// //             const finalData = {
// //                 ...userData,
// //                 picture_gallery: uploadedImageUrls,
// //             };

// //             // await addDoc(collection(db, "nv_expert_details"), finalData);
// //             await setDoc(doc(db, 'nv_expert_details', customDocId), finalData);

// //             alert("User data uploaded successfully!");
// //             setUserData({
// //                 bio: "",
// //                 insta_id: "",
// //                 name: "",
// //                 phone_no: "",
// //                 profile_image: "",
// //                 username: "",
// //                 picture_gallery: [],
// //             });
// //             setImages([]);
// //         } catch (error) {
// //             console.error("Error uploading data:", error);
// //             alert("Error uploading data.");
// //         } finally {
// //             setLoading(false);
// //         }
// //     };


// //     const deleteData = (id) => {
// //         closeModel();
// //         // Swal.fire({
// //         //     title: 'Are you sure?',
// //         //     text: "You won't be able to revert this!",
// //         //     icon: 'warning',
// //         //     showCancelButton: true,
// //         //     confirmButtonColor: '#d33',
// //         //     cancelButtonColor: '#3085d6',
// //         //     confirmButtonText: 'Yes, delete it!'
// //         // }).then((result) => {
// //         //     if (result.isConfirmed) {
// //         //         db.collection("workshop_event_data").doc(id).delete().then(() => {
// //         //             console.log('Deleted Successfully');
// //         //             setSubmit({ id: '', image: '', name: '', expert_id: '', expert: '', phone_no: '', description: '', type: '', mode: '', direction: '', instagram_id: '', start_date_time: '', zoom_link: '', passcode: '', meeting_id: '', end_date_time: '', created_date: new Date() })
// //         //             closeModel();
// //         //             Swal.fire(
// //         //                 'Deleted!',
// //         //                 'Data has been deleted.',
// //         //                 'success'
// //         //             )
// //         //         })

// //         //     }
// //         // })

// //     }

// //     useEffect(() => {
// //         db.collection("nv_expert_details").orderBy("created_date", "desc").onSnapshot((snapshot) => {

// //             setData(
// //                 snapshot.docs.map((doc) => ({
// //                     id: doc.id,
// //                     data: doc.data(),
// //                 }))
// //             );
// //         });


// //     }, []);

// //     const locations = [];


// //     return (
// //         <>
// //             <main class="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
// //                 {/* <ViewAppData /> */}
// //                 <div class="p-2" style={{ textAlign: "start", paddingBottom: "5px" }}>
// //                     {/* <span class="btn bg-gradient-secondary btn-sm mb-0 mr-2" style={{ color: "white" }} >&nbsp; Download Excel</span> */}
// //                     <Link to="/"><img src="/images/menubutton.png" class="menu-toggle" alt="Responsive image" style={{ height: "2rem" }} /></Link>

// //                 </div>

// //                 <div class="p-2">
// //                     <div style={{ textAlign: "end", paddingBottom: "5px" }}>
// //                         <a class="btn bg-gradient-primary btn-sm mb-0" style={{ color: "white" }} onClick={() => addNew()}>+&nbsp; Add Expert Details</a>
// //                         {/* <Link to="/admin_panel" class="btn bg-gradient-primary btn-sm mb-0 ml-2" style={{ color: "white" }} >&nbsp; Go Back</Link> */}
// //                     </div>
// //                     <div class="card">
// //                         <div class="">
// //                             <div class="table-responsive fix-width scroll-inner">
// //                                 <table class="table table-bordered table-hover">
// //                                     <thead class="thead-dark" style={{ position: "sticky", top: "0" }}>
// //                                         <tr style={{ textAlign: "left" }}>
// //                                             <th class="col">Expert</th>
// //                                             <th class="col ps-2">Phone</th>
// //                                             <th class="text-center col">Username</th>
// //                                             <th class="text-center col">Insta ID</th>
// //                                             <th class="text-center col">Created Date</th>
// //                                             <th class="text-center col">Action</th>
// //                                             {/* <th class="text-secondary opacity-7"></th> */}
// //                                         </tr>
// //                                     </thead>
// //                                     <tbody style={{ textAlign: "left" }}>
// //                                         {data?.map(({ id, data }, index) => (
// //                                             <>
// //                                                 <tr>
// //                                                     <td>
// //                                                         <div class="d-flex px-2 py-1">
// //                                                             <div style={{ width: "7rem", marginRight: "13px" }}>
// //                                                                 <img src={data.profile_image} class="me-3" style={{ height: "4rem" }} />
// //                                                             </div>
// //                                                             <div class="d-flex flex-column justify-content-center">
// //                                                                 <h6 class="mb-0 text-xs">{data.name}</h6>
// //                                                                 <p class="text-xs text-secondary mb-0 btn-tooltip" data-bs-toggle="tooltip" data-bs-placement="top" title={data.bio} data-container="body" data-animation="true" style={{ whiteSpace: "nowrap", width: "20rem", overflow: "hidden", textOverflow: "ellipsis" }}><i class="material-icons" style={{ fontSize: "12px", color: "#e73573" }}>info</i>  {data.bio}</p>
// //                                                             </div>
// //                                                         </div>
// //                                                     </td>
// //                                                     <td>
// //                                                         <p class="text-xs font-weight-bold mb-0">{data.phone_no}</p>
// //                                                         {/* <p class="text-xs text-secondary mb-0">Organization</p> */}
// //                                                     </td>
// //                                                     <td class="align-middle text-center text-sm">
// //                                                         <span class="badge badge-sm badge-success">{data.username}</span>
// //                                                     </td>
// //                                                     <td class="align-middle text-center text-sm">
// //                                                         <span class="badge badge-sm badge-success">{data.insta_id}</span>
// //                                                     </td>
// //                                                     <td class="align-middle text-center text-sm">
// //                                                         <span class="text-secondary text-xs font-weight-normal">{moment(data.created_date.toDate().toISOString()).format("MM/DD/YY, h:mm a")}</span>
// //                                                     </td>

// //                                                     <td class="align-middle text-center" onClick={() => changeStatus(data, id)}>
// //                                                         <span class="text-info text-xs font-weight-normal" style={{ cursor: "pointer" }}>Edit</span>
// //                                                     </td>

// //                                                 </tr>
// //                                             </>
// //                                         ))}
// //                                     </tbody>
// //                                 </table>
// //                             </div>
// //                         </div>
// //                     </div>
// //                 </div>

// //             </main>




// //             <div class="col-md-12">
// //                 <div class="myId modal fade" id="" tabindex="-1" role="dialog" aria-labelledby="modal-form" aria-hidden="true" data-backdrop="static">
// //                     <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
// //                         <div class="modal-content">
// //                             <div class="modal-body">


// //                                 <div class="">
// //                                     <form onSubmit={handleSubmit}>
// //                                         <label>Expert ID:</label>
// //                                         <input
// //                                             type="text"
// //                                             value={customDocId}
// //                                             onChange={handleCustomDocIdChange}
// //                                             required
// //                                             placeholder="Enter quiz ID (e.g., e1,e2 and so on)"
// //                                             style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
// //                                         />
// //                                         <div>
// //                                             <label>Bio:</label>
// //                                             <textarea
// //                                                 name="bio"
// //                                                 value={userData.bio}
// //                                                 onChange={handleInputChange}
// //                                                 required
// //                                                 style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
// //                                             ></textarea>
// //                                         </div>

// //                                         <div>
// //                                             <label>Instagram ID:</label>
// //                                             <input
// //                                                 type="text"
// //                                                 name="insta_id"
// //                                                 value={userData.insta_id}
// //                                                 onChange={handleInputChange}
// //                                                 required
// //                                                 style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
// //                                             />
// //                                         </div>
// //                                         <div>
// //                                             <label>Name:</label>
// //                                             <input
// //                                                 type="text"
// //                                                 name="name"
// //                                                 value={userData.name}
// //                                                 onChange={handleInputChange}
// //                                                 required
// //                                                 style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
// //                                             />
// //                                         </div>
// //                                         <div>
// //                                             <label>Phone Number:</label>
// //                                             <input
// //                                                 type="text"
// //                                                 name="phone_no"
// //                                                 value={userData.phone_no}
// //                                                 onChange={handleInputChange}
// //                                                 required
// //                                                 style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
// //                                             />
// //                                         </div>
// //                                         <div>
// //                                             <label>Profile Image URL:</label>
// //                                             <input
// //                                                 type="text"
// //                                                 name="profile_image"
// //                                                 value={userData.profile_image}
// //                                                 onChange={handleInputChange}
// //                                                 required
// //                                                 style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
// //                                             />
// //                                         </div>
// //                                         <div>
// //                                             <label>Username:</label>
// //                                             <input
// //                                                 type="text"
// //                                                 name="username"
// //                                                 value={userData.username}
// //                                                 onChange={handleInputChange}
// //                                                 required
// //                                                 style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
// //                                             />
// //                                         </div>
// //                                         <div>
// //                                             <label>Picture Gallery (4 Images):</label>
// //                                             <input
// //                                                 type="file"
// //                                                 multiple
// //                                                 accept="image/*"
// //                                                 onChange={handleImageChange}
// //                                                 required
// //                                                 style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
// //                                             />
// //                                         </div>
// //                                         <button type="submit" disabled={loading}>
// //                                             {loading ? "Uploading..." : "Upload Data"}
// //                                         </button>

// //                                     </form>
// //                                 </div>
// //                             </div>
// //                         </div>
// //                     </div>
// //                 </div>
// //             </div >

// //         </>
// //     )
// // }

// // export default ExpertUploadPage;


// // // import React, { useState } from "react";
// // // import { addDoc, collection, doc, setDoc } from "firebase/firestore";
// // // import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
// // // import db, { storage } from "./Firebase";

// // // const ExpertUploadPage = () => {
// // //     const [customDocId, setCustomDocId] = useState(""); // Custom doc ID
// // //     const [userData, setUserData] = useState({
// // //         bio: "",
// // //         insta_id: "",
// // //         name: "",
// // //         phone_no: "",
// // //         profile_image: "",
// // //         username: "",
// // //         picture_gallery: [],
// // //     });

// // //     // Handle changes in custom document ID input
// // //     const handleCustomDocIdChange = (e) => {
// // //         setCustomDocId(e.target.value);
// // //     };


// // //     const [images, setImages] = useState([]);
// // //     const [loading, setLoading] = useState(false);

// // //     const handleInputChange = (e) => {
// // //         const { name, value } = e.target;
// // //         setUserData({ ...userData, [name]: value });
// // //     };

// // //     const handleImageChange = (e) => {
// // //         setImages([...e.target.files]);
// // //     };

// // //     const uploadImagesToFirestore = async () => {
// // //         const uploadedImageUrls = [];
// // //         for (const image of images) {
// // //             const storageRef = ref(storage, `images/${image.name}`);
// // //             const uploadTask = uploadBytesResumable(storageRef, image);

// // //             await new Promise((resolve, reject) => {
// // //                 uploadTask.on(
// // //                     "state_changed",
// // //                     null,
// // //                     (error) => reject(error),
// // //                     async () => {
// // //                         const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
// // //                         uploadedImageUrls.push(downloadURL);
// // //                         resolve();
// // //                     }
// // //                 );
// // //             });
// // //         }
// // //         return uploadedImageUrls;
// // //     };

// // //     const handleSubmit = async (e) => {
// // //         e.preventDefault();
// // //         setLoading(true);

// // //         try {
// // //             const uploadedImageUrls = await uploadImagesToFirestore();
// // //             const finalData = {
// // //                 ...userData,
// // //                 picture_gallery: uploadedImageUrls,
// // //             };

// // //             // await addDoc(collection(db, "nv_expert_details"), finalData);
// // //             await setDoc(doc(db, 'nv_expert_details', customDocId), finalData);

// // //             alert("User data uploaded successfully!");
// // //             setUserData({
// // //                 bio: "",
// // //                 insta_id: "",
// // //                 name: "",
// // //                 phone_no: "",
// // //                 profile_image: "",
// // //                 username: "",
// // //                 picture_gallery: [],
// // //             });
// // //             setImages([]);
// // //         } catch (error) {
// // //             console.error("Error uploading data:", error);
// // //             alert("Error uploading data.");
// // //         } finally {
// // //             setLoading(false);
// // //         }
// // //     };


// // //     return (
// // //         <div style={{ maxWidth: "600px", margin: "0 auto", padding: "20px" }}>
// // //             <h2>Add Expert Details</h2>
// // //             <form onSubmit={handleSubmit}>
// // //                 <label>Expert ID:</label>
// // //                 <input
// // //                     type="text"
// // //                     value={customDocId}
// // //                     onChange={handleCustomDocIdChange}
// // //                     required
// // //                     placeholder="Enter quiz ID (e.g., e1,e2 and so on)"
// // //                     style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
// // //                 />
// // //                 <div>
// // //                     <label>Bio:</label>
// // //                     <textarea
// // //                         name="bio"
// // //                         value={userData.bio}
// // //                         onChange={handleInputChange}
// // //                         required
// // //                         style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
// // //                     ></textarea>
// // //                 </div>

// // //                 <div>
// // //                     <label>Instagram ID:</label>
// // //                     <input
// // //                         type="text"
// // //                         name="insta_id"
// // //                         value={userData.insta_id}
// // //                         onChange={handleInputChange}
// // //                         required
// // //                         style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
// // //                     />
// // //                 </div>
// // //                 <div>
// // //                     <label>Name:</label>
// // //                     <input
// // //                         type="text"
// // //                         name="name"
// // //                         value={userData.name}
// // //                         onChange={handleInputChange}
// // //                         required
// // //                         style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
// // //                     />
// // //                 </div>
// // //                 <div>
// // //                     <label>Phone Number:</label>
// // //                     <input
// // //                         type="text"
// // //                         name="phone_no"
// // //                         value={userData.phone_no}
// // //                         onChange={handleInputChange}
// // //                         required
// // //                         style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
// // //                     />
// // //                 </div>
// // //                 <div>
// // //                     <label>Profile Image URL:</label>
// // //                     <input
// // //                         type="text"
// // //                         name="profile_image"
// // //                         value={userData.profile_image}
// // //                         onChange={handleInputChange}
// // //                         required
// // //                         style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
// // //                     />
// // //                 </div>
// // //                 <div>
// // //                     <label>Username:</label>
// // //                     <input
// // //                         type="text"
// // //                         name="username"
// // //                         value={userData.username}
// // //                         onChange={handleInputChange}
// // //                         required
// // //                         style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
// // //                     />
// // //                 </div>
// // //                 <div>
// // //                     <label>Picture Gallery (4 Images):</label>
// // //                     <input
// // //                         type="file"
// // //                         multiple
// // //                         accept="image/*"
// // //                         onChange={handleImageChange}
// // //                         required
// // //                         style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
// // //                     />
// // //                 </div>
// // //                 <button type="submit" disabled={loading}>
// // //                     {loading ? "Uploading..." : "Upload Data"}
// // //                 </button>

// // //             </form>
// // //         </div>
// // //     );
// // // };

// // // export default ExpertUploadPage;


// // // // import React, { useState } from "react";
// // // // import { addDoc, collection, doc, setDoc } from "firebase/firestore";
// // // // import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
// // // // import db, { storage } from "./Firebase";

// // // // const ExpertUploadPage = () => {
// // // //     const [userData, setUserData] = useState({
// // // //         bio: "",
// // // //         insta_id: "",
// // // //         name: "",
// // // //         phone_no: "",
// // // //         profile_image: "",
// // // //         username: "",
// // // //         picture_gallery: [],
// // // //     });
// // // //     const [images, setImages] = useState([]);
// // // //     const [loading, setLoading] = useState(false);

// // // //     const handleInputChange = (e) => {
// // // //         const { name, value } = e.target;
// // // //         setUserData({ ...userData, [name]: value });
// // // //     };

// // // //     const handleImageChange = (e) => {
// // // //         setImages([...e.target.files]);
// // // //     };

// // // //     const uploadImagesToFirestore = async () => {
// // // //         const uploadedImageUrls = [];
// // // //         for (const image of images) {
// // // //             const storageRef = ref(storage, `images/${image.name}`);
// // // //             const uploadTask = uploadBytesResumable(storageRef, image);

// // // //             await new Promise((resolve, reject) => {
// // // //                 uploadTask.on(
// // // //                     "state_changed",
// // // //                     null,
// // // //                     (error) => reject(error),
// // // //                     async () => {
// // // //                         const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
// // // //                         uploadedImageUrls.push(downloadURL);
// // // //                         resolve();
// // // //                     }
// // // //                 );
// // // //             });
// // // //         }
// // // //         return uploadedImageUrls;
// // // //     };

// // // //     const handleSubmit = async (e) => {
// // // //         e.preventDefault();
// // // //         setLoading(true);

// // // //         try {
// // // //             const uploadedImageUrls = await uploadImagesToFirestore();
// // // //             const finalData = {
// // // //                 ...userData,
// // // //                 picture_gallery: uploadedImageUrls,
// // // //             };

// // // //             await addDoc(collection(db, "nv_expert_details"), finalData);

// // // //             alert("User data uploaded successfully!");
// // // //             setUserData({
// // // //                 bio: "",
// // // //                 insta_id: "",
// // // //                 name: "",
// // // //                 phone_no: "",
// // // //                 profile_image: "",
// // // //                 username: "",
// // // //                 picture_gallery: [],
// // // //             });
// // // //             setImages([]);
// // // //         } catch (error) {
// // // //             console.error("Error uploading data:", error);
// // // //             alert("Error uploading data.");
// // // //         } finally {
// // // //             setLoading(false);
// // // //         }
// // // //     };

// // // //     return (
// // // //         <div>
// // // //             <h2>Upload User Data</h2>
// // // //             <form onSubmit={handleSubmit}>
// // // //                 <div>
// // // //                     <label>Bio:</label>
// // // //                     <textarea
// // // //                         name="bio"
// // // //                         value={userData.bio}
// // // //                         onChange={handleInputChange}
// // // //                         required
// // // //                         style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
// // // //                     ></textarea>
// // // //                 </div>
// // // //                 <div>
// // // //                     <label>Instagram ID:</label>
// // // //                     <input
// // // //                         type="text"
// // // //                         name="insta_id"
// // // //                         value={userData.insta_id}
// // // //                         onChange={handleInputChange}
// // // //                         required
// // // //                     />
// // // //                 </div>
// // // //                 <div>
// // // //                     <label>Name:</label>
// // // //                     <input
// // // //                         type="text"
// // // //                         name="name"
// // // //                         value={userData.name}
// // // //                         onChange={handleInputChange}
// // // //                         required
// // // //                     />
// // // //                 </div>
// // // //                 <div>
// // // //                     <label>Phone Number:</label>
// // // //                     <input
// // // //                         type="text"
// // // //                         name="phone_no"
// // // //                         value={userData.phone_no}
// // // //                         onChange={handleInputChange}
// // // //                         required
// // // //                     />
// // // //                 </div>
// // // //                 <div>
// // // //                     <label>Profile Image URL:</label>
// // // //                     <input
// // // //                         type="text"
// // // //                         name="profile_image"
// // // //                         value={userData.profile_image}
// // // //                         onChange={handleInputChange}
// // // //                         required
// // // //                     />
// // // //                 </div>
// // // //                 <div>
// // // //                     <label>Username:</label>
// // // //                     <input
// // // //                         type="text"
// // // //                         name="username"
// // // //                         value={userData.username}
// // // //                         onChange={handleInputChange}
// // // //                         required
// // // //                     />
// // // //                 </div>
// // // //                 <div>
// // // //                     <label>Picture Gallery (4 Images):</label>
// // // //                     <input
// // // //                         type="file"
// // // //                         multiple
// // // //                         accept="image/*"
// // // //                         onChange={handleImageChange}
// // // //                         required
// // // //                     />
// // // //                 </div>
// // // //                 <button type="submit" disabled={loading}>
// // // //                     {loading ? "Uploading..." : "Upload Data"}
// // // //                 </button>
// // // //             </form>
// // // //         </div>
// // // //     );
// // // // };

// // // // export default ExpertUploadPage;
